import { authService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export interface AnalyticsClearSummary {
  visitors: number;
  conversations: number;
  leads: number;
  leadSegments: number;
  resourceDownloads: number;
  downloadTokens: number;
  totalCleared: number;
}

export interface AnalyticsClearResponse {
  success: boolean;
  message: string;
  summary: AnalyticsClearSummary;
  preservedData: string[];
}

class AdminService {
  private async makeRequest(url: string, options: RequestInit = {}): Promise<any> {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Not authenticated');
    }

    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(error.error || `HTTP ${response.status}`);
    }

    return response.json();
  }

  // Clear all analytics data (production-safe)
  async clearAnalyticsData(): Promise<AnalyticsClearResponse> {
    return this.makeRequest(`${API_BASE_URL}/admin/clear-analytics`, {
      method: 'POST',
    });
  }
}

export const adminService = new AdminService();
export default adminService;